export default __webpack_public_path__ + "static/media/shake1.a871d95b.jpg";